<div class="k-loading-panel" *ngIf="notificationService.loadingPanelVisible">
    <div class="k-loading-panel-mask"></div>
    <div class="k-loading-panel-wrapper text-center">
        <kendo-loader type="infinite-spinner" themeColor="primary" size="large">
        </kendo-loader>
        <div class="k-loading-panel-text">{{notificationService.message | translate}}</div>
    </div>
</div>
<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>